<template>
  <div class="row">
    <!--   <div class="col-12 mb-3">
         <button class="btn btn-primary" @click="$router.push({name: 'edit_plan' , params: {id: 'new'}})">
           افزودن
           <i class="fas fa-plus"/>
         </button>
         <hr>
       </div>-->
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو پرداخت
      </h4>
    </div>



    <div class="col-12">
      <form class="text-right" v-on:keyup.enter="beforeSearch">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="order_id" class="text-right mb-1">شماره سفارش</label>
              <input id="order_id" v-model="filters.order_id" type="text" class="fv-sm form-control"
                     placeholder="شماره سفارش">
            </div>
          </div>



          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="account_id" class="text-right mb-1">کاربر</label>
              <appUserSelect :justId="true" id="account_id" placeholder="کاربر"
                             v-model="filters.account_id"/>
            </div>
          </div>



          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="final_price" class="text-right mb-1">مبلغ نهایی پرداخت شده</label>
              <input id="final_price" type="text" class="form-control" placeholder="مبلغ نهایی پرداخت شده"
                     :value="$priceMask(filters.final_price)"
                     @input="filters.final_price = $normalNum($event.target.value)">
            </div>
          </div>




          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="price" class="text-right mb-1">مبلغ اشتراک بدون تخفیف</label>
              <input id="price" type="text" class="form-control" placeholder="مبلغ اشتراک بدون تخفیف"
                     :value="$priceMask(filters.price)" @input="filters.price = $normalNum($event.target.value)">
            </div>
          </div>




          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="discount_price" class="text-right mb-1">مبلغ اشتراک با تخفیف</label>
              <input id="discount_price" type="text" class="form-control" placeholder="مبلغ اشتراک با تخفیف"
                     :value="$priceMask(filters.discount_price)"
                     @input="filters.discount_price = $normalNum($event.target.value)">
            </div>
          </div>




          <div class="col-12 col-sm-6 col-md-8 col-lg-12 col-xl-6">
            <appRangeDatePicker fromLabel="از تاریخ ایجاد" toLabel="تا تاریخ ایجاد" v-model="filters.$and"
                                id="createdAt"/>
          </div>






          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">

            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="is_verified" class="text-right mb-1">وضعیت پرداخت</label>
              <fvSelect class="form-control select text-right fv-size-md" id="is_verified"
                        v-model="filters.is_verified"
                        :options="[{text: 'پرداخت شده' , value: true},{text: 'پرداخت نشده' , value: {$ne: true}}]"
                        placeholder="وضعیت پرداخت"
              >

                <template slot="option" slot-scope="scope">
                  <div
                      class="imageWithName">
                    <div :class="`dropdown-item-text ${scope.option.value === true ? 'text-success' : 'text-danger'}`">
                      <b>{{scope.option.text || "---"}} </b>
                    </div>
                    <div :class="`dropdown-item-text ${scope.option.value === true ? 'text-success' : 'text-danger' }`">
                      <div>
                        <i v-if="scope.option.value === true" class="far fa-check-circle"/>
                        <i v-else class="far fa-times-circle"/>
                      </div>
                    </div>
                  </div>

                </template>
                <template slot="value" slot-scope="scope">
                  <span v-if="scope.value === true">پرداخت شده</span>
                  <span v-else>پرداخت نشده</span>
                </template>
              </fvSelect>
            </div>
         </div>







          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
                <div class="form-group" v-on:keyup.enter="beforeSearch">
                  <label for="perpage" class="text-right mb-1">تعداد نمایش</label>
                  <fvSelect class="fv-form-control"
                            id="perpage"
                            @input="changePerPage"
                            :value="pagination.per_page"
                            :options="$store.state.main.per_page"
                            placeholder="تعداد نمایش"
                  >

                  </fvSelect>
                </div>
              </div>
            </div>
          </div>







          <div class="col-12 text-left d-flex">
            <button type="button" @click="$router.push({})" class="btn btn-danger ml-auto">
              حذف فیلترها
              <i class="fas fa-trash"/>
            </button>
            <button @click.prevent="beforeSearch" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>





    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">



        <template slot="field-#" , slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>



        <template slot="field-شماره سفارش" slot-scope="scope">
          {{scope.row.order_id || '---'}}
        </template>


        <template slot="field-کاربر" slot-scope="scope">
          <router-link :to="{name: 'edit_user' , params : {id: scope.row.account_id} }"

                       class="btn btn-info btn-sm">
            مشاهده پروفایل کاربر
            <i class="far fa-edit"/>
          </router-link>
        </template>



        <template slot="title-مبلغ نهایی پرداخت شده">مبلغ نهایی پرداخت شده</template>



        <template slot="field-مبلغ نهایی پرداخت شده" slot-scope="scope">
          <div>{{`${scope.row.final_price ? `${ $priceMask(scope.row.final_price)}` : '---'} `}}</div>
        </template>



        <template slot="title-مبلغ بدون تخفیف">مبلغ بدون تخفیف</template>


        <template slot="field-مبلغ بدون تخفیف" slot-scope="scope">
          <div>{{`${scope.row.price ? `${ $priceMask(scope.row.price)}` : '---'} `}}</div>
        </template>



        <template slot="title-مبلغ تخفیف">مبلغ تخفیف</template>


        <template slot="field-مبلغ تخفیف" slot-scope="scope">
          <div>{{`${scope.row.discount_price ? `${ $priceMask(scope.row.discount_price)}` : '---'} `}}</div>
        </template>

        <template slot="title-واحد پول">واحد پول</template>


        <template slot="field-واحد پول" slot-scope="scope">
          {{scope.row.currency || 'ریال'}}
        </template>



        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{$dateTimeFormat(scope.row.created_at)}}
        </template>



        <template slot="field-وضعیت" slot-scope="scope">

          <div v-if="scope.row.is_verified === true" class="text-success">
            پرداخت شده
            <i class="far fa-check-circle"/>
          </div>
          <div v-else class="text-danger">
            پرداخت نشده
            <i class="far fa-times-circle"/>
          </div>
        </template>



        <template slot="field-actions" slot-scope="scope">
          <router-link :to="{name: 'edit_order' , params : {id: scope.row.order_id} }"
                       class="btn btn-warning btn-sm">
            مشاهده
            <i class="far fa-edit"/>
          </router-link>
          <!-- <span v-if="!scope.row.is_verified"> 
            <button @click.prevent="recheck(scope.row.order_id)" class="btn btn-info m-1">
              بررسی
            </button>
          </span>-->
        </template>


      </fvTable>



    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>



  </div>



</template>
<script>

	import { mapActions } from "vuex";
import appCategorySelect from "../../components/appCategorySelect";
import appGendersSelect from "../../components/appGendersSelect";
import appPagination from "../../components/appPagination";
import appRangeDatePicker from "../../components/appRangeDatePicker";
import appUserSelect from "../../components/appUserSelect";

	export default {
		name: 'orders',
		components: {
			appPagination,
			appUserSelect,
			appRangeDatePicker,
			appGendersSelect,
			appCategorySelect,
    },



		data() {
			return {
				...mapActions('main', [
					'crud'
				]),
				item: [],
				fields: ['#', 'شماره سفارش', 'کاربر', 'مبلغ بدون تخفیف', 'مبلغ تخفیف', 'مبلغ نهایی پرداخت شده','واحد پول', 'تاریخ ثبت', 'وضعیت', 'actions'],
				query: {},
				filters: {},
				sort: {},
				page: 1,
				pagination: {per_page: 50}
			}
    },




		methods: {
			parseQueries() {
				const {query} = this.$route
				const {page, filters, sort, per_page} = query;
				const filtersObj = filters ? JSON.parse(filters) : {}

				this.sort = sort
				this.filters = filtersObj
				this.query = query
				this.page = page ? parseInt(page) : 1
				this.pagination.per_page = per_page
      },



			async getData() {
				this.parseQueries()
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const apiFilters = await this.$generateFilter(this.filters)
					// if (apiFilters.is_verified === null)
					//   delete apiFilters.is_verified

					const item = await this.crud({
						action: 'get',
						section: 'orders',
						query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}&sort=-created_at`,
						perPage: this.pagination.per_page
					})
					if (item.data && item.data.items) {
						const result = item.data.items
						this.item = result
						this.pagination = item.data.pagination
					}
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
      },



			async search() {
				this.filters = await this.$validateFilter(this.filters)
				await this.$router.push({
					query: {
						filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
						sort: this.sort || undefined,
						page: this.page,
						per_page: this.pagination.per_page
					}
				})
      },




			beforeSearch() {
				this.page = 1
				this.search()
      },


			changePerPage(value) {
				this.pagination.per_page = value
				this.beforeSearch()
			},
    },



		async created() {
			await this.getData()
    },


		watch: {
			'$route.query'() {
				this.getData();
			}
		},

		// beforeUpdate() {
		// }
	};
</script>
<style>
</style>
